import { render, staticRenderFns } from "./TradingPolicy.vue?vue&type=template&id=4df77767&scoped=true"
import script from "./TradingPolicy.vue?vue&type=script&lang=ts"
export * from "./TradingPolicy.vue?vue&type=script&lang=ts"
import style0 from "./TradingPolicy.vue?vue&type=style&index=0&id=4df77767&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df77767",
  null
  
)

export default component.exports